import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { List, ListItem, ListItemText, ListItemButton } from "@mui/material";
import Widget from "./widget";
import Grid from "@mui/material/Grid2";

function ScreenZone(props) {
  const { scrDefinition, scrZone } = props;
  const [section, setSection] = useState();
  useEffect(() => {
    if (scrDefinition?.sections?.length > 0) {
      setSection(
        scrDefinition.sections.filter((s) => s.SCREEN_ZONE == scrZone)?.[0]
      );
    }
  }, [scrDefinition?.sections]);
  if (!section) return;
  return (
    <div id={`scr-${scrZone}`} className={`scr-${scrZone}`}>
      {scrDefinition?.sections?.filter((s) => s.SCREEN_ZONE == scrZone).length >
        1 && (
        <List id={`sl-${scrZone}`} className="scr-list" dense>
          {scrDefinition.sections
            .filter((s) => s.SCREEN_ZONE == scrZone)
            .map((s) => {
              return (
                <ListItem
                  id={`sli-${s.SECTION_ID}`}
                  key={s.SECTION_ID}
                  onClick={() => setSection(s)}
                  sx={{ padding: "0px 0px" }}
                >
                  <ListItemButton
                    id={`slib-${section.SECTION_ID}`}
                    selected={s.SECTION_CODE == section?.SECTION_CODE}
                  >
                    <ListItemText
                      id={`slit-${section.SECTION_ID}`}
                      primary={s.SECTION_TEXT}
                      sx={{ textAlign: "center" }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
        </List>
      )}

      {section && (
        <div className="scr-section">
          {section?.SECTION_TEXT && (
            <div id={`st-${section.SECTION_ID}`} className="section-title">
              {section.SECTION_TEXT}
            </div>
          )}
          {/*<div className="scr-widgets" >*/}
          <Grid container spacing={2} className="scr-widgets" columns={12}>
            {scrDefinition?.sectionWidgets
              ?.filter((s) => s.SECTION_ID == section.SECTION_ID)
              .map((s) =>
                scrDefinition?.widgets?.map((w) => {
                  if (w.WIDGET_ID == s.WIDGET_ID) {
                    return (
                      <Widget
                        id={`szw-${w.SECTION_ID}-${w.WIDGET_ID}`}
                        key={w.WIDGET_ID}
                        scrDefinition={scrDefinition}
                        wData={w}
                      />
                    );
                  }
                })
              )}
          </Grid>
        </div>
      )}
    </div>
  );
}
export default observer(ScreenZone);
